import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

import { sendFeedback } from "@Http/feedback";
import { MutationError } from "@Types/index";
import { FeedbackData } from "@Pages/HelpCenter/Feedback/Feedback";

export const useSendFeedback = () => {
  const mutation = useMutation<object, MutationError, FeedbackData>(
    sendFeedback(),
    {
      onSuccess: () => {
        toast.success("Successfully sent feedback.", {
          position: "top-center",
        });
      },
    }
  );
  return {
    send: mutation.mutateAsync,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};
